var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notification",class:{
    'notification-error': _vm.notification.variant === 'error',
    'notification-success': _vm.notification.variant === 'success',
    'notification-info': _vm.notification.variant === 'info',
  }},[_c('span',[_vm._v(_vm._s(_vm.notification.message))]),_vm._v(" "),_c('button',{staticClass:"notification-close",on:{"click":_vm.onClose}},[_c('svg-icon',{attrs:{"name":"icon/close"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }